export class MechanicalAxisLTConfig {
}
MechanicalAxisLTConfig.weightBearing_color = 0x00ff00;
//# sourceMappingURL=FullAnalyzerLTConfig.js.map